(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const revealSelector = [
    '.nourgan-reveal',
    '[data-nourgan-animate]',
    '.nourgan-about__principle',
  ].join(', ');
  let observer;
  let frame;

  const showImmediately = (elements) => elements.forEach((element) => element.classList.add('is-visible'));

  const setStagger = (scope) => {
    scope.querySelectorAll?.('[data-nourgan-stagger], .showcase-grid, .nourgan-about__principles-grid').forEach((group) => {
      [...group.children].forEach((child, index) => {
        if (!child.matches(revealSelector) || child.style.getPropertyValue('--nourgan-reveal-delay')) return;
        child.style.setProperty('--nourgan-reveal-delay', `${Math.min(index, 5) * 70}ms`);
      });
    });
  };

  const reveal = (scope = document) => {
    setStagger(scope);
    const elements = [...(scope.querySelectorAll?.(revealSelector) || [])].filter(
      (element) => !element.dataset.nourganReveal && !element.closest('[hidden]')
    );
    if (!elements.length) return;

    elements.forEach((element) => {
      element.dataset.nourganReveal = 'true';
      element.classList.add('nourgan-motion-item');
    });

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      showImmediately(elements);
      return;
    }

    observer ||= new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -9% 0px', threshold: 0.08 });

    elements.forEach((element) => observer.observe(element));
  };

  const updateHeader = () => {
    frame = undefined;
    document.documentElement.toggleAttribute('data-nourgan-scrolled', window.scrollY > 16);
  };

  const requestHeaderUpdate = () => {
    if (frame !== undefined) return;
    frame = window.requestAnimationFrame(updateHeader);
  };

  const initialise = () => {
    document.documentElement.classList.add('nourgan-motion-ready');
    reveal();
    updateHeader();
    window.addEventListener('scroll', requestHeaderUpdate, { passive: true });
  };

  document.addEventListener('DOMContentLoaded', initialise, { once: true });
  document.addEventListener('shopify:section:load', (event) => reveal(event.target));
  reduceMotion.addEventListener?.('change', () => {
    if (reduceMotion.matches) showImmediately([...document.querySelectorAll('.nourgan-motion-item')]);
  });
})();
